module.exports = __webpack_public_path__ + "img/mt5-icon9.bfb7c4a.png";